/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import * as antd from 'antd';
import qs from 'qs';

import { AppContext } from '../AppContext';
import { AddNews } from '../modals/AENews';
import { DangerButton } from '../components/DangerButton';
import dayjs from 'dayjs';

const NewsPage = () => {
  const appCtx = React.useContext(AppContext);

  const [spinning, setSpinning] = React.useState<boolean>(false);
  const [dataSource, setDataSource] = React.useState<News[]>([]); //coulmns data
  const [currentPage, setCurrentPage] = React.useState<number>(1);
  const [total, setTotal] = React.useState<number>(0);
  const pageSize = 10;

  const init = async (page = currentPage, title?: string) => {
    setSpinning(true);
    const pagination = {
      sort: 'createdAt:desc',
      populate: ['images'],
      pagination: { page, pageSize },
      filters: title ? { title: { $contains: title } } : undefined,
    };
    const data = await appCtx.fetch(
      'get',
      '/api/news?' + qs.stringify(pagination),
    );
    if (data) {
      const temp = data.data.map((item: any) => {
        return {
          id: item.id,
          ...item.attributes,
        };
      });

      console.log(temp);
      setDataSource(temp);
      setTotal(data.meta.pagination.total);
      setCurrentPage(data.meta.pagination.page);
      setSpinning(false);
    }
  };

  React.useEffect(() => {
    appCtx.redirect();
  }, []);

  React.useEffect(() => {
    if (appCtx.jwt) {
      init();
    }
  }, [appCtx.jwt]);

  interface News {
    title: string;
    content: string;
    startDate: string;
    endDate: string;
    isTop: boolean;
    createdAt: string;
  }

  const deleteNews = async (id: number) => {
    await appCtx.fetch('delete', `/api/news/${id}`);
    init();
  };

  const columns: ColumnsType<News> = [
    {
      title: '標題',
      align: 'center',
      dataIndex: 'title',
    },

    {
      title: '內容',
      align: 'left',
      width: '30%',
      dataIndex: 'content',
    },
    {
      title: '圖片',
      align: 'center',
      render: (item) => (
        <div className="flex justify-center items-center space-x-3">
          <antd.Image.PreviewGroup>
            {item.images?.data &&
              item.images.data.map((image: any) => {
                return <antd.Image width={80} src={image.attributes.url} />;
              })}
          </antd.Image.PreviewGroup>
        </div>
      ),
    },
    {
      title: '起始日期',
      align: 'center',
      dataIndex: 'startDate',
    },
    {
      title: '結束日期',
      align: 'center',
      dataIndex: 'endDate',
    },
    {
      title: '是否置頂',
      align: 'center',
      render: (item) => <antd.Switch checked={item.isTop} />,
    },
    {
      title: '創建日期',
      align: 'center',
      render: (item) => (
        <>{dayjs(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}</>
      ),
    },
    {
      title: '操作',
      align: 'center',
      width: 180,
      render: (item) => (
        <>
          <antd.Button
            className="mr-3"
            type="primary"
            onClick={() =>
              appCtx.setModal(<AddNews item={item} onSuccess={init} />)
            }
          >
            編輯
          </antd.Button>
          <DangerButton
            title="刪除"
            message="確定要刪除活動紀錄?"
            onClick={() => deleteNews(item.id)}
          />
        </>
      ),
    },
  ];

  return (
    <antd.Spin spinning={spinning}>
      <div className="flex  mb-2">
        <antd.Input.Search
          placeholder="搜尋標題"
          onSearch={(value) => init(currentPage, value)}
          style={{ width: 200 }}
        />

        <div className="flex-1" />
        <antd.Button
          type="primary"
          onClick={() => appCtx.setModal(<AddNews onSuccess={init} />)}
        >
          新增
        </antd.Button>
      </div>
      <antd.Table
        dataSource={dataSource}
        columns={columns}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: total,
          onChange: (page) => init(page),
        }}
      />
    </antd.Spin>
  );
};

export { NewsPage };
